export const getHypoUpdate = (store) => store.component.hypoglycemia;
export const getBloodSugarUpdate = (store) => store.component.bloodSugar;
export const getCalculateDate = (store) => store.component.calculatedate;
export const getPageId = (store) => store.component.pageStatus;
export const getRecordDate = (store) => store.component.recordDate;
export const getHeading = (store) => store.component.heading;
export const getPageStatusData = (store) => store.component.pageStatusData;
export const getFlage = (store) => store.component.flage;
export const getFormDate = (store) => store.component.date || null;
export const getSelectedVisitDate = (store) => store.component.visitDate;
